<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import CommonSharedMdm from '@common/mixins/CommonSharedMdm';
import { mdmType } from '@common/constants/mdm';
import {
  Menu,
  hideSearch,
  actionButtons,
  defaultSearchParameters,
} from '@/constants/mdm-v2/header';
import { listHeaders } from '@/constants/mdm-v2/listConstants';
import { uploadSampleFileName } from '@/constants/mdm-v2/uploadConstants';
import { formConstants } from '@/constants/mdm-v2/formConstants';
import { searchConstants } from '@/constants/mdm-v2/searchConstants';

const MDM = {
  mixins: [CommonSharedMdm],
  data() {
    return {
      // following are imports from mdm constants file
      Menu,
      defaultSearchParameters,
      hideSearch,
      actionButtons: cloneDeep(actionButtons),
      mdmType,
      listHeaders,
      uploadSampleFileName,
      formConstants,
      searchConstants,
    };
  },
  created() {
    // Getting current section name from route url
    this.currentSection = this.$router.history.current.name.toLowerCase();
    this.setConstants();
    this.searchParameters.forEach((param) => {
      this.defaultValues[`${param.query}`] =
        this.filter[`${param.query}`] || null;
    });
    this.$store.commit('mdmV2/initialReset', []);
  },
  computed: {
    ...mapGetters({
      isPaginating: 'mdmV2/isPaginating',
      isUploading: 'mdmV2/isUploading',
      filter: 'mdmV2/filter',
      isLoading: 'mdmV2/isLoading',
      list: 'mdmV2/list',
      hasEmpty: 'mdmV2/hasEmpty',
      configHeaders: 'mdmV2/header',
      currentUser: 'app/currentUser',
      mdmBoostrap: 'app/mdmBoostrap',
    }),
  },
  methods: {
    async getExcel() {
      try {
        await this.$store.dispatch('mdmV2/getExcelHeader', {
          section: this.currentSection,
        });
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    saveSearchToSession(searchedParams) {
      const sessionSearch = JSON.stringify(searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
  },
};
export default MDM;
</script>
